import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'selectGridButtonText',
  pure: true
})
export class SelectGridButtonTextPipe implements PipeTransform {
  private readonly i18nPipe = inject(I18NextPipe);

  transform(count: number, oneEntityKey: string, manyEntitiesKey: string, isSelectAllOnAllPages: boolean): string {
    const selected = this.i18nPipe.transform('common.selected', { format: 'capitalize' });
    const entities = this.i18nPipe.transform(count === 1 ? oneEntityKey : manyEntitiesKey);
    const page = this.i18nPipe.transform('paging.' + (isSelectAllOnAllPages ? 'onAllPages' : 'onThisPage'));

    return `${selected} ${count} ${entities} ${page}`;
  }
}
